module.exports = __webpack_public_path__ + "static/media/neha-profile.0737f7a3.png";